import { render, staticRenderFns } from "./defaultWithoutHeading.vue?vue&type=template&id=f1420270&"
import script from "./defaultWithoutHeading.vue?vue&type=script&lang=js&"
export * from "./defaultWithoutHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports